(function () {
  'use strict';
  if (window.SissiluxBfcmRewards) return;
  const bound = new WeakSet();
  const attempts = new Map();
  const memory = new Map();
  const timers = new WeakMap();
  const upsellAnchors = new WeakMap();
  let checkoutPending = false;
  let replayCheckout = false;
  const read = view => {
    try { return JSON.parse(view.querySelector('[data-gpt-gift-state]')?.textContent || '{}'); }
    catch (_) { return {}; }
  };
  const consent = () => {
    try { return !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed || window.Shopify.customerPrivacy.analyticsProcessingAllowed(); }
    catch (_) { return false; }
  };
  const storageKey = state => 'sissilux:bfcm:' + state.campaignId + ':' + String(state.cartToken || '').split('?')[0];
  function previous(state) {
    const key = storageKey(state);
    if (memory.has(key)) return memory.get(key);
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); }
    catch (_) { return null; }
  }
  function remember(state, next) {
    const key = storageKey(state);
    memory.set(key, next);
    if (!consent()) return;
    try { sessionStorage.setItem(key, JSON.stringify(next)); } catch (_) {}
  }
  function emit(name, state, extra = {}) {
    if (!state.campaignId || !consent()) return;
    try {
      const detail = {
        event:name,
        campaign_id:state.campaignId,
        campaign_name:state.campaignName,
        event_location:'Cart Drawer',
        cart_value:state.cartValue / 100,
        eligible_cart_value:state.eligibleCartValue / 100,
        reward_tier:state.activeTier === 2 ? 'Premium' : state.activeTier === 1 ? 'Standard' : 'None',
        country:state.country,
        eligibleQuantity:Number(state.eligibleQuantity) || 0,
        specialQuantity:Number(state.specialQuantity) || 0,
        rewardReason:state.rewardReason,
        reward_quantity:state.rewardReason === 'product' ? state.specialThreshold : state.activeTier === 2 ? state.premiumQuantity : state.activeTier === 1 ? state.standardQuantity : state.rewardQuantity,
        quantity_remaining:Number(state.quantityRemaining) || 0,
        warranty_in_cart:Boolean(state.warrantyInCart),
        currency:state.currency,
        operation_id:window.crypto?.randomUUID?.() || String(Date.now()) + '-' + Math.random().toString(36).slice(2),
        ...extra
      };
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(detail);
      document.dispatchEvent(new CustomEvent('sissilux:bfcm-event', {detail}));
    } catch (_) {}
  }
  function observeState(view) {
    const state = read(view);
    if (!state.campaignId) return;
    const old = previous(state);
    const freeGifts = (state.giftLines || []).filter(line => Number(line.chargedCents) === 0 && Number(line.quantity) > 0);
    const quantities = {};
    for (const line of freeGifts) quantities[line.variantId] = (quantities[line.variantId] || 0) + Number(line.quantity);
    const freeGift = freeGifts[0];
    const signature = Object.keys(quantities).sort().map(id => id + ':' + quantities[id]).join('|');
    const next = {tier:state.activeTier, gift:freeGift?.variantId || null, signature, warranty:Boolean(state.warrantyInCart), seen:old?.seen || []};
    remember(state, next);
    if (old && state.campaignEnabled) {
      if (next.tier !== old.tier && next.tier > 0) emit(next.tier === 2 ? 'bfcm_premium_gift_unlocked' : 'bfcm_standard_gift_unlocked', state);
      if (next.warranty !== old.warranty) emit(next.warranty ? 'bfcm_warranty_add' : 'bfcm_warranty_remove', state);
      if (next.gift !== old.gift || (old.signature !== undefined && next.signature !== old.signature)) {
        if (next.gift) emit(old.gift ? 'bfcm_gift_changed' : 'bfcm_gift_selected', state, {gift_id:next.gift, gift_name:freeGift.name, gift_quantities:quantities, gift_quantity:freeGifts.reduce((sum, line) => sum + Number(line.quantity), 0)});
        else if (old.gift) emit('bfcm_gift_removed', state, {gift_id:old.gift});
      }
    }
    const controller = window.__gptGiftControllerV2;
    const choices = [...new Set((state.selectableVariantIds || []).map(String))];
    const attemptKey = storageKey(state);
    if (state.activeTier !== 1 || (state.giftLines || []).length) attempts.delete(attemptKey);
    if (controller && state.selectionMode !== 'multiple' && state.selectionMode !== 'tiered' && state.campaignEnabled && state.claimsEnabled && state.autoApplyStandard && state.activeTier === 1 && choices.length === 1 && !(state.giftLines || []).length && !controller.hasPendingChanges && !controller.desiredVariantId && !controller.operationCount) {
      const attempt = [state.country, state.eligibleQuantity, state.specialQuantity, state.rewardReason, choices[0]].join(':');
      if (attempts.get(attemptKey) !== attempt) {
        attempts.set(attemptKey, attempt);
        queueMicrotask(() => controller.requestSelection(choices[0]));
      }
    }
  }
  function markSeen(view, name) {
    const state = read(view);
    if (!state.campaignEnabled) return;
    const old = previous(state) || {tier:state.activeTier,gift:null,warranty:Boolean(state.warrantyInCart),seen:[]};
    if (old.seen.includes(name)) return;
    old.seen.push(name);
    remember(state, old);
    emit(name, state);
  }
  const visibility = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) {
      markSeen(entry.target, 'bfcm_reward_progress_view');
      if (entry.target.querySelector('[data-gm-gift-card]')) markSeen(entry.target, 'bfcm_gift_view');
      visibility.unobserve(entry.target);
    }
  }, {threshold:0.2}) : null;
  function expire(view) {
    if (!view.isConnected) return;
    const state = read(view);
    const end = Date.parse(state.endsAt);
    if (!Number.isFinite(end)) return;
    const delay = end - Date.now();
    if (delay > 0) {
      timers.set(view, setTimeout(() => expire(view), Math.min(delay, 2147483647)));
      return;
    }
    state.campaignEnabled = false;
    state.claimsEnabled = false;
    if (state.promotion) state.promotion = {...state.promotion, enabled:false};
    state.activeTier = 0;
    state.selectableVariantIds = [];
    view.querySelector('[data-gpt-gift-state]').textContent = JSON.stringify(state);
    view.querySelectorAll('[data-gm-gift-card], [data-gm-gift-adjust]').forEach(card => {card.disabled = true;card.setAttribute('aria-disabled','true');});
    if (state.hideAfterEnd) {
      view.classList.add('gpt-gift-milestones--hidden');
      if (state.selectionMode === 'tiered') view.hidden = true;
    }
    else {
      const message = view.querySelector('.bfcm-rewards__message');
      if (message) message.textContent = state.endedLabel;
      view.querySelector('.bfcm-rewards__gifts')?.setAttribute('hidden','');
    }
    window.__gptGiftControllerV2?.requestReconciliation();
    view.dispatchEvent(new CustomEvent('sissilux:bfcm-state', {bubbles:true}));
  }
  function bind(view) {
    if (bound.has(view)) return;
    bound.add(view);
    observeState(view);
    visibility?.observe(view);
    expire(view);
  }
  function placeHandMasks() {
    document.querySelectorAll('[data-bfcm-hand-mask]').forEach(upsell => {
      const scope = upsell.closest('cart-drawer') || document;
      const view = scope.querySelector('[data-bfcm-rewards]');
      const state = view ? read(view) : {};
      const slot = view?.querySelector('[data-bfcm-hand-mask-slot]');
      const available = slot && (state.selectionMode === 'multiple' || state.selectionMode === 'tiered') && state.campaignEnabled && Number(state.eligibleQuantity) > 0;
      if (available) {
        if (upsell.parentElement !== slot) {
          let anchor = upsellAnchors.get(upsell);
          if (!anchor?.isConnected) {
            anchor = document.createComment('Original paid add-on position');
            upsell.before(anchor);
            upsellAnchors.set(upsell, anchor);
          }
          slot.append(upsell);
        }
        upsell.hidden = false;
      } else {
        const anchor = upsellAnchors.get(upsell);
        if (anchor?.isConnected && anchor.nextSibling !== upsell) anchor.after(upsell);
        upsell.hidden = !upsell.hasAttribute('data-bfcm-device-addon') && upsell.dataset.originalDisplay !== 'true' && upsell.dataset.hasPaidMask !== 'true';
      }
    });
  }
  function scan() { document.querySelectorAll('[data-bfcm-rewards]').forEach(bind); placeHandMasks(); }
  document.addEventListener('click', async event => {
    if (replayCheckout) return;
    const button = event.target.closest?.('button[name="checkout"], a[href="/checkout"]');
    const controller = window.__gptGiftControllerV2;
    const view = document.querySelector('[data-bfcm-rewards]');
    const bonus = window.SissiluxBfcmBonus;
    const bonusState = view ? read(view).bonus : null;
    const bonusNeedsAttention = Boolean(bonus?.pending || bonusState?.enabled || bonusState?.lines?.length);
    const giftNeedsAttention = Boolean(view && ['multiple', 'tiered'].includes(read(view).selectionMode) && controller?.safeForCheckout === false);
    if (!button || !controller || !view || (!read(view).managementEnabled && !bonusNeedsAttention) || !(controller.operationCount || controller.desiredVariantId || controller.hasPendingChanges || checkoutPending || bonusNeedsAttention || giftNeedsAttention)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const giftState = read(view);
    if (giftState.unifiedChoices && Object.keys(controller.tierSelections(giftState)).length > controller.quantityAllowance(giftState)) {
      const limit = controller.quantityAllowance(giftState);
      controller.showError(`Your gift allowance changed. Choose ${limit} gift${limit === 1 ? '' : 's'} to keep before checkout.`);
      view.querySelector('[data-gm-choice-group]')?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      return;
    }
    if (checkoutPending) return;
    checkoutPending = true;
    try {
      if (giftNeedsAttention) controller.requestReconciliation();
      if (bonusNeedsAttention && !bonus) {
        controller.showError(bonusState.errorLabel || read(view).errorLabel);
        return;
      }
      await bonus?.ensure();
      // A completed removal can enqueue the replacement Standard gift. Wait for
      // that follow-up too before passing the click to the native warranty guard.
      let settled = false;
      for (let round = 0; round < 8; round++) {
        const queue = controller.operationQueue;
        await queue;
        await Promise.resolve();
        if (queue === controller.operationQueue && !controller.operationCount && !controller.desiredVariantId && !controller.hasPendingChanges) {
          settled = true;
          break;
        }
      }
      if (!settled || controller.safeForCheckout === false || (bonus && !bonus.settled)) {
        controller.showError(read(view).errorLabel);
        return;
      }
      const current = button.id ? document.getElementById(button.id) : button;
      if (!current?.isConnected) return;
      replayCheckout = true;
      current.click();
    } finally {
      replayCheckout = false;
      checkoutPending = false;
    }
  }, true);
  document.addEventListener('sissilux:bfcm-state', event => {
    if (event.target.matches?.('[data-bfcm-rewards]')) { observeState(event.target); placeHandMasks(); }
  });
  document.addEventListener('click', event => {
    const view = document.querySelector('[data-bfcm-rewards]');
    if (!view) return;
    const state = read(view);
    if (!state.campaignEnabled) return;
    if (event.target.closest?.('button[name="checkout"], a[href="/checkout"]') && !event.target.disabled) emit('bfcm_checkout_start', state);
  });
  customElements.whenDefined('gpt-gift-milestones').then(() => {
    scan();
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-bfcm-rewards], [data-bfcm-hand-mask]') || node.querySelector?.('[data-bfcm-rewards], [data-bfcm-hand-mask]'))))) scan();
      for (const record of records) for (const node of record.removedNodes) {
        if (node.nodeType !== 1) continue;
        const views = node.matches?.('[data-bfcm-rewards]') ? [node] : [...node.querySelectorAll?.('[data-bfcm-rewards]') || []];
        for (const oldView of views) { clearTimeout(timers.get(oldView));visibility?.unobserve(oldView); }
      }
    }).observe(document.body,{childList:true,subtree:true});
  });
  window.SissiluxBfcmRewards = {emit,read,scan};
})();
